<script>
import { mapActions, mapGetters } from 'vuex';
import ListItem from './components/ListItem';
import SaveDialog from './components/SaveDialog';
import snackbarMixin from '@/mixins/snackbar';
import moment from 'moment';

export default {
  name: 'kyeFormu',
  components: {
    ListItem,
    SaveDialog,
  },
  mixins: [snackbarMixin],
  data() {
    return {
      hasError: false,
      isInitialized: false,
      isLoading: false,
      isSaving: false,
      itemList: [],
      saveDialogData: {
        item: {},
        visible: false,
        isCreateMode: false,
      },
      sortBy: 'id',
      descending: true,
      search: '',
    };
  },
  computed: {
    ...mapGetters('kyeFormu', ['listHeaders']),
  },
  mounted() {
    this.initializeData();
  },
  methods: {
    ...mapActions('kyeFormu',['getList', 'reject', 'approve', 'save', 'delete']),
    ...mapActions('app', ['showOverlay', 'hideOverlay']),
    fetchData() {
      this.isLoading = true;
      this.showOverlay();
      this.getList()
        .then((data) => {
          this.itemList = data.data;
          this.isInitialized = true;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
          this.hideOverlay();
        });
    },
    initializeData() {
      this.showOverlay();

      this.isLoading = true;
      Promise.all([this.getList()])
        .then(([odemeTalepResult]) => {
          this.itemList = odemeTalepResult.data;
          this.isInitialized = true;
          this.isLoading = false;
          this.hideOverlay();
        }, () => {
          this.hasError = true;
          this.isLoading = false;
        });
    },
    async handleSave(item) {
      this.isSaving = true;

      const response = await this.save(item);
      if (response.status === 200 && response.data > 0) {
        this.showSuccessMessage('Form kaydedildi');
        this.saveDialogData.visible = false;
        this.fetchData();
      } else {
        this.hasError = true;
        this.showErrorMessage(response.data);
      }

      this.isLoading = false;
    },
    async handleDelete(id) {
      this.isSaving = true;

      const response = await this.delete(id);
      if (response.status === 200 && response.data > 0) {
        this.showSuccessMessage('Form silindi!');
        this.saveDialogData.visible = false;
        this.fetchData();
      } else {
        this.hasError = true;
        this.showErrorMessage(response.data);
      }

      this.isLoading = false;
    },
    openSaveDialog(data) {
      this.saveDialogData.item = data;
      this.saveDialogData.visible = true;
    },
    closeSaveDialog() {
      this.saveDialogData.visible = false;
    },
    customFilter(value, search, item) {
      // eslint-disable-next-line eqeqeq
      if (!search || search == '') {
        return true;
      }

      const searchStr = search.toString().toLowerCase().trim();

      return !!(
        // eslint-disable-next-line eqeqeq
        item.id == searchStr
        || item.tedarikciUnvani.toString().toLowerCase().trim().includes(searchStr)
        || item.vergiNo.toString().toLowerCase().trim().includes(searchStr)
        || (item.olusturmaTarihi && moment(new Date(item.olusturmaTarihi)).format('DD.MM.YYYY hh:mm').toLowerCase().trim().includes(searchStr))
      );
    },
  },
};
</script>

<template>
  <div>
    <template v-if="hasError">
      <p class="js-error-template ma-3">
        KYE Form listesinde bir hata oluştu. Lütfen tekrar deneyin!
      </p>
    </template>

    <template v-else>
      <v-toolbar dark dense color="#9FA8A3">
        <b> {{ $t('kyeFormList') }} </b>
        <v-spacer />
        <v-btn @click="openSaveDialog(null)" style="align-self: right;"> {{ $t('addNewForm') }}</v-btn>
      </v-toolbar>


      <v-card>
        <v-card-title>
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </v-card-title>
        <v-data-table
          :loading="isLoading"
          :headers="listHeaders"
          :items="itemList"
          :sort-by.sync="sortBy"
          :sort-desc.sync="descending"
          :search="search"
          :custom-filter="customFilter"
          class="elevation-1 spec-table"
          item-key="Id"
        >
          <template slot="item" slot-scope="props">
            <list-item
              :item="props.item"
              @details="openSaveDialog(props.item, false)"
            />
            
          </template>
        </v-data-table>
      </v-card>
    </template>

    <save-dialog
      v-if="saveDialogData.visible"
      @refresh="fetchData"
      @close="closeSaveDialog"
      :item="saveDialogData.item"
      :is-create-mode="saveDialogData.isCreateMode"
      @save="handleSave"
      @delete="handleDelete"

    />
    
  </div>
</template>
